/**
 * Türkçe Çeviri Dosyası
 *
 * NOT: Bu projenin yazılımcısının ana dili Türkçe'dir.
 * Bu dosya önce Türkçe olarak yazılmış, sonra İngilizce çevirisi yapılmıştır.
 * Türkçe çeviriler ana kaynak olarak kabul edilir.
 */
export const tr = {
  // Common
  common: {
    loading: 'Yükleniyor...',
    error: 'Hata',
    sort: 'Sırala',
    sortAsc: 'Artan sırala',
    sortDesc: 'Azalan sırala',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    remove: 'Kaldır',
    edit: 'Düzenle',
    view: 'İncele',
    copy: 'Kopyala',
    create: 'Oluştur',
    update: 'Güncelle',
    search: 'Ara',
    actions: 'İşlemler',
    code: 'Kod',
    all: 'Tümü',
    clear: 'Temizle',
    filter: 'Filtre',
    yes: 'Evet',
    no: 'Hayır',
    confirm: 'Onayla',
    close: 'Kapat',
    select: 'Seçiniz',
    active: 'Aktif',
    inactive: 'Pasif',
    success: 'Başarılı',
    updated: 'Güncellendi',
    created: 'Oluşturuldu',
    deleted: 'Silindi',
    confirmDelete: 'Silmek istediğinizden emin misiniz?',
    errorOccurred: 'Bir hata oluştu',
    noData: 'Veri yok',
    status: 'Durum',
    show: 'Göster',
    hide: 'Gizle',
    searchPlaceholder: 'Ara...',
    allStatuses: 'Tüm Durumlar',
    clearFilters: 'Filtreleri Temizle',
    newRecord: 'Yeni Kayıt',
    noPermission: 'Bu işlem için yetkiniz yok',
    statusDistribution: 'Durum Dağılımı',
    rows: 'Satır',
    firstPage: 'İlk Sayfa',
    previousPage: 'Önceki Sayfa',
    nextPage: 'Sonraki Sayfa',
    lastPage: 'Son Sayfa',
    page: 'Sayfa',
    optional: 'İsteğe Bağlı',
    saving: 'Kaydediliyor...',
    deleteConfirmTitle: 'Silmeyi Onayla',
    deleteWarning: 'Bu işlem geri alınamaz!',
    autoTranslate: 'Otomatik Çevir',
    autoTranslateSuccessCount: '{count} kayıt otomatik çevrildi.',
    autoTranslateNoSource: 'Kaynak çeviri bulunamadı.',
    enterTargetLanguage: 'Hedef dil seçiniz.',
    sourceLanguageLabel: 'Kaynak Dil (UI diliniz)',
    targetLanguage: 'Hedef Dil',
    sourceAndTargetMustDiffer: 'Kaynak ve hedef dil farklı olmalıdır.',
    context: 'Tablo',
    key: 'Sütun',
    value: 'Değer',
    locale: 'Dil',
    auto: 'Otomatik',
    manual: 'Manuel',
    manageLocales: 'Dilleri Yönet',
    activeLocalesDescription: 'Aktif dilleri seçin. Yalnızca tercih olarak kaydedilir.',
    updateUntranslatedFields: 'Yeni Alanları Senkronize Et',
    syncEntriesResult: '{count} yeni çeviri girişi senkronize edildi.',
    syncDeletedResult: '{count} sahipsiz giriş kaldırıldı.',
    selectSourceLanguageForSync: 'İçerikler hangi dilde?',
    sourceLanguage: 'Kaynak Dil',
    originalShort: 'Org.',
    languageNames: { en: 'İngilizce', tr: 'Türkçe', de: 'Almanca', fr: 'Fransızca', es: 'İspanyolca', ar: 'Arapça', it: 'İtalyanca', ja: 'Japonca', zh: 'Çince', ru: 'Rusça' } as Record<string, string>,
    perPage: 'Sayfa Başına',
    darkMode: 'Karanlık Mod',
    lightMode: 'Aydınlık Mod',
    copyright: '© {year} QubePro. Tüm hakları saklıdır.',
    translationRates: 'Çeviri Oranları',
    profileMenu: 'Profil Menüsü',
    manageYourAccount: 'Hesabınızı yönetin',
    adminConsole: 'Yönetim Konsolu',
    serverConfiguring: 'Sunucu yapılandırılıyor, lütfen bekleyiniz...',
    productName: 'Yönetim',
  },

  // Portal
  portal: {
    searchPlaceholder: 'Uygulama ara...',
    noAppsFound: 'Uygulama bulunamadı.',
    quickLinks: 'Hızlı Bağlantılar',
    console: 'Yönetim Konsolu',
    lastLogin: 'Son Giriş',
    apps: {
      core: { name: 'Yönetim', description: 'Şirketleri, organizasyonları, kullanıcıları, rolleri ve izinleri merkezi bir platformda yönetin.' },
      bi: { name: 'Analitik', description: 'Verilerinizden raporlar ve gösterge panelleri oluşturun. İş verilerini içgörülere ve kararlara dönüştürün.' },
      bpm: { name: 'İş Akışları', description: 'İç talepleri, onayları ve görev süreçlerini dijital ortamda başlatın, takip edin ve tamamlayın.' },
      support: { name: 'Destek', description: 'Müşteri taleplerini ve destek biletlerini yönetin. Sorunları tek bir yerden takip edin ve çözün.' },
      agent: { name: 'Otomasyon', description: 'Tekrarlayan görevleri botlar ve ajanlarla otomatikleştirin. Mevcut araçlarınızla entegre edin.' },
      ai: { name: 'Yapay Zeka & Tahminler', description: 'Veri analizi ve tahmin için YZ modellerini kullanın. Planlama ve kararları geliştirin.' },
      erp: { name: 'İş Paketi', description: 'Finans, satış, depo ve operasyonlar için entegre modüller. İşinizi tek bir platformda yürütün.' },
      pms: { name: 'Projeler', description: 'Projeleri planlayın, görevler atayın, ilerlemeyi takip edin ve ekibinizle tek bir yerde iş birliği yapın.' },
      crm: { name: 'Müşteri İlişkileri', description: 'Kişileri, fırsatları ve satış hattını yönetin. Tüm müşteri bilgileri ve geçmişi tek yerde.' },
    },
    menus: {
      core_dashboard: 'Gösterge Paneli',
      core_companies: 'Firmalar',
      core_organizations: 'Organizasyonlar',
      core_roles: 'Roller',
      core_users: 'Kullanıcılar',
      core_groups: 'Gruplar',
      core_emails: 'E-Posta Hesapları',
      core_data_sources: 'Veri Kaynakları',
      core_settings_company: 'Firma Ayarları',
      core_settings_user: 'Kullanıcı Ayarları',
      core_translations: 'Çeviriler',
    },
  },

  // Panel (ERP ana sayfa modül listesi)
  panel: {
    apps: {
      crm: { name: 'CRM', footerName: 'CRM' },
      accounting: { name: 'Muhasebe' },
      finance: { name: 'Finans' },
      procurement: { name: 'Tedarik' },
      inventory: { name: 'Ürün ve Stok Yönetimi', footerName: 'Envanter' },
      purchase: { name: 'Satın Alma' },
      sales: { name: 'Satış' },
      manufacturing: { name: 'Üretim' },
      assets: { name: 'Varlıklar' },
      hr: { name: 'İnsan Kaynakları' },
      project: { name: 'Proje Yönetimi' },
      timesheet: { name: 'Çalışma Çizelgeleri' },
      documents: { name: 'Belgeler' },
      pos: { name: 'Satış Noktası' },
      rental: { name: 'Kiralama' },
      dashboard: { name: 'Rapor Paneli' },
    },
    appsLabel: 'Uygulamalar',
    settingsLabel: 'Ayarlar',
    coreLabel: 'Yönetim',
    backToHome: 'Ana Sayfaya Dön',
  },

  // Errors
  errors: {
    unknown: 'Bilinmeyen bir hata oluştu',
    network: 'Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.',
    timeout: 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.',
    badRequest: 'Geçersiz istek',
    unauthorized: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
    forbidden: 'Bu işlem için yetkiniz bulunmuyor.',
    notFound: 'İstenen kaynak bulunamadı',
    tooManyRequests: 'Çok fazla istek gönderildi. Lütfen daha sonra tekrar deneyin.',
    internalServerError: 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.',
    badGateway: 'Sunucu geçici olarak kullanılamıyor',
    serviceUnavailable: 'Servis geçici olarak kullanılamıyor',
    gatewayTimeout: 'Sunucu yanıt vermiyor',
    serverErrorWithStatus: 'Sunucu hatası ({status})',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Merkezi Yönetim Sistemi Özeti',
    welcome: 'Hoş Geldiniz',
    guestName: 'Kullanıcı',
    statusSummary: 'Mevcut durum özetiniz',
    currentTimeLabel: 'Mevcut Saat',
    todayLabel: 'Bugün',
    activeCompanies: 'Aktif Firmalar',
    activeOrganizations: 'Aktif Organizasyonlar',
    activeUsers: 'Aktif Kullanıcılar',
    activeRoles: 'Aktif Roller',
    database: 'Veritabanı',
    databaseUsed: 'Kullanılan Alan',
    recentlyAddedUsers: 'Son Eklenen Kullanıcılar',
    recentlyAddedCompanies: 'Son Eklenen Firmalar',
    noUsersYet: 'Henüz kullanıcı yok',
    noCompaniesYet: 'Henüz firma yok',
    userPanel: 'Kullanıcı Paneli',
    userPanelWelcome: 'Hoş geldiniz! Kullanıcı ayarlarınıza menüden ulaşabilirsiniz.',
    quickActions: 'Hızlı İşlemler',
    systemHealthTitle: 'Sistem Sağlığı',
    systemLogsTitle: 'Sistem Logları',
    logChartTitle: 'Log Hata/Uyarı Dağılımı',
    logErrorsLabel: 'Hata',
    logWarningsLabel: 'Uyarı',
    logSuccessLabel: 'Başarılı',
    statusHealthy: 'Çalışıyor',
    statusFailed: 'Hata',
    statusUnknown: 'Bilinmiyor',
    lastRun: 'Son Çalışma',
    failures24h: '24s Hata',
    noData: 'Veri yok',
    systemComponents: {
      EMAIL_INGEST: 'Gelen Posta (IMAP)',
      EMAIL_DISPATCH: 'Giden Posta (SMTP)',
      JOB_SCHEDULER: 'Zamanlayıcı',
      API: 'API',
    },
  },

  // Sidebar
  sidebar: {
    dashboard: 'Gösterge Paneli',
    roles: 'Roller',
    users: 'Kullanıcılar',
    settings: 'Ayarlar',
    systemSettings: 'Sistem Ayarları',
    userSettings: 'Kullanıcı Ayarları',
    organizations: 'Organizasyonlar',
    logout: 'Çıkış Yap',
    toggleMenu: 'Menüyü Aç',
    toggleMenuClose: 'Menüyü Kapat',
    management: 'Yönetim',
    companies: 'Firmalar',
    emailAccounts: 'E-Posta Hesapları',
    dataSources: 'Veri Kaynakları',
    translations: 'Çeviriler',
    activityLogs: 'Aktivite Günlükleri',
  },

  // Settings
  settings: {
    title: 'QubePro ERP',
    subtitle: 'Firma ve kullanıcı ayarlarını yönetin',
    companySettingsSubtitle: 'Genel firma ayarlarını burada yönetin',
    userSettingsSubtitle: 'Kullanıcı ayarlarınızı burada yönetin',
    securitySettingsSubtitle: 'Şifre ve güvenlik ayarlarını burada yönetin',
    companySettings: 'Firma Ayarları',
    userSettings: 'Kullanıcı Ayarları',
    general: 'Genel Ayarlar',
    personal: 'Kişisel Ayarlar',
    timezone: 'Saat Dilimi',
    dateFormat: 'Tarih Formatı',
    defaultCurrency: 'Varsayılan Para Birimi',
    defaultLanguage: 'Varsayılan Dil',
    language: 'Dil',
    companySettingsSaved: 'Firma ayarları başarıyla kaydedildi',
    userSettingsSaved: 'Kullanıcı ayarları başarıyla kaydedildi',
    failedToLoad: 'Ayarlar yüklenemedi',
    saveFailed: 'Ayarlar kaydedilemedi',
    profilePicture: 'Profil Fotoğrafı',
    maxFileSize: 'Maks. dosya boyutu: 5 MB. Formatlar: JPEG, PNG, GIF, WebP',
    change: 'Değiştir',
    uploading: 'Yükleniyor...',
    deleteAvatar: 'Profil Fotoğrafını Sil',
    deleteAvatarConfirm: 'Profil fotoğrafını silmek istediğinizden emin misiniz?',
    avatarUploaded: 'Profil fotoğrafı yüklendi',
    avatarDeleted: 'Profil fotoğrafı silindi',
    avatarUploadError: 'Profil fotoğrafı yüklenirken hata',
    avatarDeleteError: 'Profil fotoğrafı silinirken hata',
    onlyImageFiles: 'Yalnızca resim dosyaları kabul edilir',
    fileSizeError: 'Dosya boyutu 5 MB altında olmalıdır',
    appearance: 'Görünüm',
    theme: 'Tema',
    light: 'Açık',
    dark: 'Koyu',
    pageSize: 'Tablo Sayfa Boyutu',
    defaultCompany: 'Varsayılan Firma',
    selectDefaultCompany: 'Varsayılan firma seçin',
    noCompaniesAssigned: 'Atanmış firma yok',
    security: 'Güvenlik',
    changePassword: 'Şifre Değiştir',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    confirmNewPassword: 'Yeni Şifre (Tekrar)',
    passwordChanged: 'Şifre başarıyla değiştirildi',
    passwordChangeFailed: 'Şifre değiştirilemedi',
    passwordMismatch: 'Yeni şifreler eşleşmiyor',
    passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
    passwordSameAsOld: 'Yeni şifre mevcut şifre ile aynı olamaz',
    changingPassword: 'Şifre değiştiriliyor...',
  },

  // Organizations
  organizations: {
    title: 'Organizasyonlar',
    code: 'Kod',
    name: 'Organizasyon Adı',
    description: 'Açıklama',
    logo: 'Logo',
    logoEmpty: 'Logo Yok',
    uploadLogo: 'Logo Yükle',
    status: 'Durum',
    smtp: 'SMTP',
    imap: 'IMAP',
    smtpEmailAccount: 'SMTP E-Posta Hesabı',
    imapEmailAccount: 'IMAP E-Posta Hesabı',
    active: 'Aktif',
    inactive: 'Pasif',
    newOrganization: 'Yeni Organizasyon',
    editOrganization: 'Organizasyonu Düzenle',
    deleteConfirm: 'Bu organizasyonu silmek istediğinizden emin misiniz?',
    deleteFailed: 'Organizasyon silinemedi',
    operationFailed: 'İşlem başarısız',
    failedToLoad: 'Organizasyonlar yüklenemedi',
    dataFormatError: 'Organizasyon verisi beklenmedik formatta',
    searchPlaceholder: 'Organizasyon ara (ad, açıklama)',
    empty: 'Veri yok',
    notSet: 'Seçilmedi',
    noCreatePermission: 'Organizasyon oluşturma yetkiniz yok',
    noUpdatePermission: 'Organizasyon güncelleme yetkiniz yok',
    noDeletePermission: 'Organizasyon silme yetkiniz yok',
    company: 'Firma Adı',
    statusDistribution: 'Organizasyon Durum Dağılımı',
  },

  // Users
  users: {
    title: 'Kullanıcılar',
    newUser: 'Yeni Kullanıcı',
    editUser: 'Kullanıcıyı Düzenle',
    noUsersYet: 'Veri yok',
    failedToLoad: 'Kullanıcılar yüklenemedi',
    deleteConfirm: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
    deleteFailed: 'Kullanıcı silinemedi',
    operationFailed: 'İşlem başarısız',
    passwordRequired: 'Şifre gereklidir',
    passwordChangeHint: '(Değiştirmek için doldurun)',
    fullName: 'Ad Soyad',
    email: 'E-Posta',
    status: 'Durum',
    roles: 'Roller',
    actions: 'İşlemler',
    firstName: 'Ad *',
    lastName: 'Soyad *',
    password: 'Şifre',
    noRoles: 'Rol yok',
    rolesNotFound: 'Rol bulunamadı',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    statusSuspended: 'Askıya Alındı',
    userInfoFailed: 'Kullanıcı bilgileri yüklenemedi',
    rolesFailed: 'Roller yüklenemedi',
    copy: 'Kopyala',
    isAdmin: 'Admin',
    groups: 'Gruplar',
    groupCount: 'Grup Sayısı',
    userGroupName: 'Grup Adı',
    userGroupCode: 'Grup Kodu',
    userGroupEmail: 'Grup E-Postası',
    groupManager: 'Grup Yöneticisi',
    members: 'Üyeler',
    userGroupDescription: 'Açıklama',
    userGroupCreate: 'Yeni Grup Oluştur',
    userGroupEdit: 'Grubu Düzenle',
    manageMembers: 'Üyeleri Yönet',
    addMember: 'Üye Ekle',
    memberCount: 'Üye Sayısı',
    searchUsers: 'Kullanıcı ara...',
    noMembers: 'Henüz üye yok',
    selectUser: 'Kullanıcı seçin',
    addUser: 'Ekle',
    removeUser: 'Kaldır',
    manageGroups: 'Grupları Yönet',
    noUsersFound: 'Veri yok',
    statusDistribution: 'Kullanıcı Durum Dağılımı',
    groupStatusDistribution: 'Grup Durum Dağılımı',
  },

  // Roles
  roles: {
    title: 'Roller',
    newRole: 'Yeni Rol',
    editRole: 'Rolü Düzenle',
    noRolesYet: 'Veri yok',
    failedToLoad: 'Roller yüklenemedi',
    deleteConfirm: 'Bu rolü silmek istediğinizden emin misiniz?',
    deleteFailed: 'Rol silinemedi',
    operationFailed: 'İşlem başarısız',
    dataFormatError: 'Veri format hatası',
    permissionsFailed: 'İzinler yüklenemedi',
    name: 'Rol Adı *',
    description: 'Açıklama',
    permissions: 'İzinler',
    permissionCount: 'İzin Sayısı',
    type: 'Rol Türü',
    typeSystem: 'Sistem',
    typeCustom: 'Özel',
    typeAll: 'Tüm Roller',
    searchPlaceholder: 'Ara (rol adı, açıklama, izin)...',
    systemBadge: 'Sistem',
    permissionsCount: 'İzinler ({count})',
    morePermissions: '+{count} daha',
    copy: 'Kopyala',
    copySuffix: ' (Kopya)',
    clearFilters: 'Filtreleri Temizle',
    noCreatePermission: 'Rol oluşturma yetkiniz yok',
    noUpdatePermission: 'Rol güncelleme yetkiniz yok',
    noDeletePermission: 'Rol silme yetkiniz yok',
    systemRoleEditBlocked: 'Sistem rolü düzenlenemez',
    systemRoleDeleteBlocked: 'Sistem rolü silinemez',
    noPermissions: 'İzin yok',
    paginationRange: '{start}-{end} / {total}',
    paginationPage: 'Sayfa {page} / {total}',
    modules: {
      users: 'Kullanıcılar',
      groups: 'Gruplar',
      userGroupName: 'Grup Adı',
      userGroupCode: 'Grup Kodu',
      groupManager: 'Grup Yöneticisi',
      members: 'Üyeler',
      userGroupDescription: 'Açıklama',
      userGroupCreate: 'Yeni Grup Oluştur',
      userGroupEdit: 'Grubu Düzenle',
      roles: 'Roller',
      tenant: 'Kiracı',
      userSettingField: 'Ayar',
      settings: 'Ayarlar',
      organizations: 'Organizasyonlar',
    },
    groups: 'Gruplar',
    userGroup: 'Grup',
    userGroupList: 'Grup Listesi',
    userGroupCreate: 'Grup Oluştur',
    userGroupEdit: 'Grubu Düzenle',
    userGroupName: 'Grup Adı',
    userGroupDescription: 'Açıklama',
    userGroupCode: 'Kod',
    groupManager: 'Grup Yöneticisi',
    members: 'Üyeler',
    addMember: 'Üye Ekle',
    assignRole: 'Rol Ata',
    assign: 'Ata',
    statusDistribution: 'Rol Durum Dağılımı',
    assignRoleMatrix: 'Rol Matrisi',
    roleMatrix: 'Rol Matrisi',
    selectCompanyToViewMatrix: 'Matrisi görüntülemek için firma seçin',
    show: 'Göster',
    hide: 'Gizle',
  },

  // Companies
  companies: {
    title: 'Firmalar',
    newCompany: 'Yeni Firma',
    editCompany: 'Firmayı Düzenle',
    noCompaniesYet: 'Veri yok',
    failedToLoad: 'Firmalar yüklenemedi',
    deleteConfirm: 'Bu firmayı silmek istediğinizden emin misiniz?',
    deleteFailed: 'Firma silinemedi',
    operationFailed: 'İşlem başarısız',
    dataFormatError: 'Veri format hatası',
    name: 'Firma Adı *',
    status: 'Durum',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    searchPlaceholder: 'Ara (firma adı, durum)...',
    clearFilters: 'Filtreleri Temizle',
    copy: 'Kopyala',
    copySuffix: ' (Kopya)',
    noCreatePermission: 'Firma oluşturma yetkiniz yok',
    noUpdatePermission: 'Firma güncelleme yetkiniz yok',
    noDeletePermission: 'Firma silme yetkiniz yok',
    paginationRange: '{start}-{end} / {total}',
    paginationPage: 'Sayfa {page} / {total}',
    allStatuses: 'Tüm Durumlar',
    statusDistribution: 'Firma Durum Dağılımı',
    show: 'Göster',
    hide: 'Gizle',
    logo: 'Logo',
    logoEmpty: 'Logo Yok',
    uploadLogo: 'Logo Yükle',
    smtpEmailAccount: 'SMTP E-Posta Hesabı',
    imapEmailAccount: 'IMAP E-Posta Hesabı',
    smtpEmailId: 'SMTP E-Posta Hesabı',
    imapEmailId: 'IMAP E-Posta Hesabı',
  },

  // Emails
  emails: {
    title: 'E-Posta Hesapları',
    newEmail: 'Yeni E-Posta Hesabı',
    editEmail: 'E-Posta Hesabını Düzenle',
    noEmailsYet: 'Veri yok',
    failedToLoad: 'E-posta hesapları yüklenemedi',
    deleteConfirm: 'Bu e-posta hesabını silmek istediğinizden emin misiniz?',
    deleteConfirmMessage: '"{name}" e-posta hesabını silmek istediğinizden emin misiniz?',
    deleteFailed: 'E-posta hesabı silinemedi',
    operationFailed: 'İşlem başarısız',
    dataFormatError: 'Veri format hatası',
    name: 'Hesap Adı',
    type: 'Tür',
    host: 'Sunucu',
    port: 'Port',
    user: 'Kullanıcı Adı',
    password: 'Şifre',
    fromEmail: 'Gönderen E-Posta',
    secure: 'Güvenli (SSL/TLS)',
    secureConnection: 'Güvenli Bağlantı (SSL/TLS)',
    status: 'Durum',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    activate: 'Aktif Et',
    deactivate: 'Pasif Et',
    isActive: 'Aktif',
    searchPlaceholder: 'Ara (ad, sunucu, kullanıcı)...',
    clearFilters: 'Filtreleri Temizle',
    copy: 'Kopyala',
    noCreatePermission: 'E-posta hesabı oluşturma yetkiniz yok',
    noUpdatePermission: 'E-posta hesabı güncelleme yetkiniz yok',
    noDeletePermission: 'E-posta hesabı silme yetkiniz yok',
    paginationRange: '{start}-{end} / {total}',
    paginationPage: 'Sayfa {page} / {total}',
    allStatuses: 'Tüm Durumlar',
    allTypes: 'Tüm Türler',
    statusDistribution: 'Hesap Durum Dağılımı',
    show: 'Göster',
    hide: 'Gizle',
    nameRequired: 'Hesap adı gereklidir',
    hostRequired: 'Sunucu gereklidir',
    portRequired: 'Port gereklidir',
    userRequired: 'Kullanıcı adı gereklidir',
    passwordRequired: 'Şifre gereklidir',
    leaveBlankToKeep: 'Değiştirmemek için boş bırakın',
    noData: 'Veri yok',
    noEmailsMessage: 'Veri yok',
    passwordEditHint: 'Değiştirmemek için boş bırakın',
    noSearchResults: 'Veri yok',
    namePlaceholder: 'örn. Şirket Destek veya info@firma.com',
    deleteConfirmTitle: 'Hesabı Sil',
  },

  // DataSources
  dataSources: {
    title: 'Veri Kaynakları',
    subtitle: 'Müşteri veritabanı bağlantılarını yönetin',
    newDataSource: 'Yeni Veri Kaynağı',
    editDataSource: 'Veri Kaynağını Düzenle',
    noDataSourcesYet: 'Veri yok',
    failedToLoad: 'Veri kaynakları yüklenemedi',
    deleteConfirm: 'Bu veri kaynağını silmek istediğinizden emin misiniz?',
    deleteFailed: 'Veri kaynağı silinemedi',
    operationFailed: 'İşlem başarısız',
    dataFormatError: 'Veri format hatası',
    name: 'Görünen Ad',
    driver: 'Sürücü',
    server: 'Sunucu',
    port: 'Port',
    databaseName: 'Veritabanı Adı',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    schema: 'Şema',
    sourceType: 'Kaynak Türü',
    source: 'Kaynak',
    target: 'Hedef',
    sourceSystem: 'Kaynak Sistem',
    targetSystem: 'Hedef Sistem',
    status: 'Durum',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    searchPlaceholder: 'Ara (ad, sunucu, veritabanı)...',
    clearFilters: 'Filtreleri Temizle',
    copy: 'Kopyala',
    paginationRange: '{start}-{end} / {total}',
    paginationPage: 'Sayfa {page} / {total}',
    allStatuses: 'Tüm Durumlar',
    allTypes: 'Tümü',
    statusDistribution: 'Veri Kaynağı Durum Dağılımı',
    show: 'Göster',
    hide: 'Gizle',
    nameRequired: 'Görünen ad gereklidir',
    serverRequired: 'Sunucu adresi gereklidir',
    databaseRequired: 'Veritabanı adı gereklidir',
    passwordRequired: 'Şifre gereklidir',
    testConnection: 'Bağlantıyı Test Et',
    testing: 'Test ediliyor...',
    testSuccess: 'Bağlantı başarılı!',
    testFailed: 'Bağlantı başarısız: ',
    integratedSecurity: 'Entegre Güvenlik',
    ssl: 'SSL',
    connectionTimeout: 'Bağlantı Zaman Aşımı (sn)',
    description: 'Açıklama',
    noCreatePermission: 'Veri kaynağı oluşturma yetkiniz yok',
    noUpdatePermission: 'Veri kaynağı güncelleme yetkiniz yok',
    noDeletePermission: 'Veri kaynağı silme yetkiniz yok',
  },

  // AI Providers
  aiProviders: {
    title: 'Yapay Zeka Sağlayıcıları',
    subtitle: 'YZ modellerini ve entegrasyonlarını yönetin',
    newProvider: 'Yeni YZ Sağlayıcısı',
    editProvider: 'YZ Sağlayıcısını Düzenle',
    noProvidersYet: 'Veri yok',
    failedToLoad: 'YZ sağlayıcıları yüklenemedi',
    deleteConfirm: 'Bu YZ sağlayıcısını silmek istediğinizden emin misiniz?',
    deleteFailed: 'YZ sağlayıcısı silinemedi',
    operationFailed: 'İşlem başarısız',
    name: 'Sağlayıcı Adı *',
    provider: 'Sağlayıcı Türü',
    baseUrl: 'Temel URL',
    apiKey: 'API Anahtarı',
    description: 'Açıklama',
    status: 'Durum',
    statusActive: 'Aktif',
    statusInactive: 'Pasif',
    searchPlaceholder: 'Ara (ad, tür, url)...',
    clearFilters: 'Filtreleri Temizle',
    noCreatePermission: 'YZ sağlayıcısı oluşturma yetkiniz yok',
    statusDistribution: 'YZ Sağlayıcısı Durum Dağılımı',
    baseUrlPlaceholder: 'örn. http://localhost:11434, https://api.custom.ai/v1',
    baseUrlEmptyDefault: 'Varsayılan için boş bırakın',
    apiKeyPlaceholder: 'API Anahtarı Girin',
  },

  // Login
  login: {
    title: 'QubePro ERP',
    subtitle: 'Merkezi Yönetim Sistemi',
    heroTitle: 'Kurumsal yönetimi tek ekrandan yönetin',
    heroSubtitle: 'QubePro ERP, şirket ve organizasyon yönetiminden kullanıcı ve rol yönetimine kadar tüm süreçleri tek bir merkezi platformda birleştirir.',
    languageToggleLabel: 'Dil seçimi',
    turkish: 'Türkçe',
    english: 'English',
    email: 'E-Posta',
    password: 'Şifre',
    emailPlaceholder: 'ornek@domain.com',
    emailHint: "Domain'e göre tenant otomatik belirlenir",
    passwordPlaceholder: '••••••••',
    loginButton: 'Giriş Yap',
    loggingIn: 'Giriş yapılıyor...',
    loginFailed: 'Giriş başarısız',
    darkMode: 'Karanlık Mod',
    lightMode: 'Aydınlık Mod',
    featureTitle: 'Kurumsal Kaynak Planlaması',
    featureDescription: 'Müşteri ilişkileri, satış, envanter ve finansal süreçlerinizi tek bir entegre platformda yönetin.',
    featureCard1Title: 'Müşteri Yönetimi',
    featureCard1Description: 'Müşterilerinizi, potansiyel satışları ve ticari ilişkilerinizi merkezi olarak takip edin.',
    featureCard2Title: 'Satış ve Siparişler',
    featureCard2Description: 'Teklifler, siparişler ve satış süreçlerini kolayca yönetin, gelirlerinizi artırın.',
    featureCard3Title: 'Raporlar ve Analitik',
    featureCard3Description: 'Gerçek zamanlı raporlar ve göstergelerle iş performansınızı izleyin, veri odaklı kararlar alın.',
    featureCard4Title: 'Entegrasyon ve Ayarlar',
    featureCard4Description: 'Sisteminizi özelleştirin, diğer araçlarla entegre edin ve iş süreçlerinizi otomatikleştirin.',
    pleaseWait: 'Lütfen Bekleyiniz',
    serverConfiguring: 'Sunucu yapılandırılıyor, lütfen bekleyiniz...',
    dbCreating: 'Veritabanı ve gerekli yapılandırmalar oluşturuluyor. Bu işlem birkaç saniye sürebilir.',
    loginPageTitle: 'Giriş',
    submitButton: 'Giriş',
    emailLabel: 'E-posta',
    passwordLabel: 'Şifre',
    emailPlaceholderFull: 'E-posta adresinizi giriniz',
    passwordPlaceholderFull: 'Şifre Giriniz',
    showPassword: 'Şifreyi göster',
    hidePassword: 'Şifreyi gizle',
    emailRequired: 'E-posta adresi gereklidir',
    passwordRequired: 'Şifre gereklidir',
    backendUnavailable: 'Backend sunucusu şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.',
    backendConnectFailed: 'Backend sunucusuna bağlanılamadı. Lütfen daha sonra tekrar deneyin.',
    backendConnectFailedDev: 'Backend sunucusuna bağlanılamadı. Lütfen backend sunucusunun çalıştığından emin olun ({apiUrl}).',
    fieldEmail: 'E-posta',
    fieldPassword: 'Şifre',
    errors: {
      invalidCredentials: 'Geçersiz e-posta veya şifre. Lütfen tekrar deneyin.',
      databaseUnavailable: 'Veritabanı kullanılamıyor veya kurulum gerekiyor. Lütfen tekrar giriş yapın.',
      accountInactive: 'Hesabınız aktif değil. Lütfen sistem yöneticinizle iletişime geçin.',
      sessionExpired: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
      tooManyAttempts: 'Çok fazla deneme. Lütfen daha sonra tekrar deneyin.',
      sessionTooLarge: 'Oturum verisi çok büyük. Lütfen tekrar giriş yapın.',
    },
  },

};
